import { render, staticRenderFns } from "./LoginNotify.vue?vue&type=template&id=2ec3aa7a"
import script from "./LoginNotify.vue?vue&type=script&lang=js"
export * from "./LoginNotify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports